module.exports = __webpack_public_path__ + "static/img/1.c9006ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/zh/1.png
// module id = Gk9A
// module chunks = 0